import { Option } from '@storeblocks/select';
import { CarCoverage } from 'Types/coverages/coverages.types';
import { CoverageOption } from './changeCarForm.types';

export const yearlyKmNeedOptions: Option[] = [
  {
    label: '5 000 km',
    value: '8',
  },
  {
    label: '8 000 km',
    value: '1',
  },
  {
    label: '12 000 km',
    value: '2',
  },
  {
    label: '16 000 km',
    value: '3',
  },
  {
    label: '20 000 km',
    value: '4',
  },
  {
    label: '25 000 km',
    value: '5',
  },
  {
    label: '30 000 km',
    value: '6',
  },
  {
    label: '40 000 km',
    value: '7',
  },
  {
    label: 'Ubegrenset',
    value: '99',
  },
];

export const superCoverageV2: CoverageOption = {
  id: 'super',
  label: 'Super',
  trackid: 'super',
  value: CarCoverage.FULL_SUPER_V2,
};

export const superCoverageOld: CoverageOption = {
  id: 'super',
  label: 'Super',
  trackid: 'super',
  value: CarCoverage.FULL_SUPER,
};

export const kaskoCoverageCar = (disabled: boolean): CoverageOption => {
  return {
    disabled,
    id: 'kasko',
    label: 'Kasko',
    trackid: 'kasko',
    value: CarCoverage.FULL_OWN_DAMAGE,
  };
};

export const delkaskoCoverageCar = (disabled: boolean): CoverageOption => {
  return {
    disabled,
    id: 'delkasko',
    label: 'Delkasko',
    trackid: 'delkasko',
    value: CarCoverage.REDUCED_OWN_DAMAGE,
  };
};

export const ansvarCoverageCar = (disabled: boolean): CoverageOption => {
  return {
    disabled,
    id: 'ansvar',
    label: 'Ansvar',
    trackid: 'ansvar',
    value: CarCoverage.ACCIDENT,
  };
};
